import React from "react";
// import './bootstrap.css'
import "./eventsAndChallenges.css";
import ChallengesManagement from "./ChallengesManagement";
import EventsManagement from "./EventsManagement";

const EventsAndChallenges: React.FC = () => {
  const [showEvents, setShowEvents] = React.useState(true);

  return (
    <div className="header2">
      <div className="container">
        <h2 className="top-heading">Workshop Management</h2>
        <EventsManagement />

      </div>
    </div >
  );
};

export default EventsAndChallenges;
